// extracted by mini-css-extract-plugin
module.exports = {"root":"stockStatusMessage_root__nDMwv border-l-4 border-solid border-error font-semibold leading-normal text-error text-sm"};